module.exports = __webpack_public_path__ + "img/logo2_trial.80f370af.png";